<template>
  <transition name="slide-fade" appear>
    <slot></slot>
  </transition>
</template>

<style scoped>
.slide-fade-enter {
  transition: all 0.3 ease-in;
}
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}
</style>